import { RETRIEVE_DASHBOARD } from '../../actions/types';

const initialState = {
    case_status: [],
    cases: {},
    products: [],
    product_case_progress: {},
    last_12_month: [],
    response_completed_histogram: [],
    new_cases: [],
    sla_dashboard_monitor_summary: {
        at_risk_lane_count: 0,
        approaching_lane_count: 0,
        resolution_escalation_unacked: 0,
    },
    sla_dashboard_monitor_cases: [],
};

function dashboardReducer(dashboard = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case RETRIEVE_DASHBOARD:
            return payload;
        default:
            return dashboard;
    }
}
export default dashboardReducer;
